import { render } from "./AssetTypeEditData.vue?vue&type=template&id=53842de2"
import script from "./AssetTypeEditData.vue?vue&type=script&lang=js"
export * from "./AssetTypeEditData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__